// src/services/mataMataService.js
import { configuredAxios as api } from './axiosConfig'; // ajuste o caminho se necessário

const mataMataService = {
  getKnockoutBracket: (championshipId) => {
    if (!championshipId) {
      console.error("[mataMataService] ID do campeonato é necessário para getKnockoutBracket.");
      return Promise.reject({
        success: false,
        message: "ID do campeonato é necessário.",
        status: 400
      });
    }
    return api.get(`/championships/${championshipId}/knockout`)
      .then(res => res.data); // pega apenas o .data se você quiser simplificar
  },

  generateKnockoutStage: (championshipId) => {
    if (!championshipId) {
      console.error("[mataMataService] ID do campeonato é necessário para generateKnockoutStage.");
      return Promise.reject({
        success: false,
        message: "ID do campeonato é necessário.",
        status: 400
      });
    }
    return api.post(`/championships/${championshipId}/generate-knockout`)
      .then(res => res.data);
  }
};

export default mataMataService;
